const state = {
  dropdown_close_trigger: 0,
};

const getters = {
  dropdown_close_trigger(state) {
    return state.dropdown_close_trigger;
  },
};

const mutations = {
  incrementDropdownCloseTrigger(state) {
    state.dropdown_close_trigger++;
  },
};

const actions = {
  incrementDropdownCloseTrigger(context) {
    context.commit('incrementDropdownCloseTrigger');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
